import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login?error=no_session');
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing Emergent session:', sessionId.substring(0, 10) + '...');

        // Exchange session_id for user data via backend
        const response = await fetch(`${API_URL}/api/auth/emergent/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({ detail: 'Auth failed' }));
          throw new Error(error.detail || 'Authentication failed');
        }

        const data = await response.json();
        
        if (data.success && data.user) {
          // Store session token in localStorage as backup
          if (data.session_token) {
            localStorage.setItem('emergent_session_token', data.session_token);
          }
          
          // Store user info
          localStorage.setItem('emergent_user', JSON.stringify(data.user));
          
          // Clear the hash and redirect to dashboard
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { state: { user: data.user }, replace: true });
        } else {
          throw new Error('Invalid response from auth server');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate(`/login?error=${encodeURIComponent(error.message)}`);
      }
    };

    processAuth();
  }, [navigate, location.hash]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-white/20 border-t-white rounded-full mx-auto mb-4" />
        <p className="text-white/60">Completing sign in...</p>
      </div>
    </div>
  );
}
